(function () {
  'use strict';

  var LIGHTBOX_ID = 'kit-product-image-lightbox';
  var lightbox = null;
  var lightboxImage = null;
  var lightboxPrev = null;
  var lightboxNext = null;
  var lightboxCounter = null;
  var galleryState = null;

  function getThumbItem(element) {
    return element && element.closest
      ? element.closest('[class*="__thumb"]:not([class*="__thumb-"])')
      : null;
  }

  function getThumbLargeSrc(thumbImg) {
    if (!thumbImg) return '';
    return (
      thumbImg.getAttribute('data-large-src') ||
      thumbImg.getAttribute('src') ||
      ''
    );
  }

  function rememberInitialSrc(mainImg) {
    if (!mainImg.getAttribute('data-kit-initial-src')) {
      var src = mainImg.getAttribute('src') || '';
      if (src) mainImg.setAttribute('data-kit-initial-src', src);
    }
  }

  function getLightboxSrc(container, mainImg) {
    if (!mainImg) return '';

    rememberInitialSrc(mainImg);

    var src = mainImg.getAttribute('src') || '';
    var initialSrc = mainImg.getAttribute('data-kit-initial-src') || '';

    if (src && initialSrc && src !== initialSrc) {
      return src;
    }

    var activeThumb = container
      ? container.querySelector('[class*="__thumb"].is-active:not([class*="__thumb-"])')
      : null;
    if (activeThumb) {
      var activeSrc = getThumbLargeSrc(activeThumb.querySelector('img'));
      if (activeSrc) return activeSrc;
    }

    return mainImg.getAttribute('data-lightbox-src') || src;
  }

  function collectGallerySlides(container, mainImg) {
    var slides = [];
    var seen = {};

    function addSlide(src, alt) {
      if (!src || seen[src]) return;
      seen[src] = true;
      slides.push({ src: src, alt: alt || '' });
    }

    addSlide(
      mainImg.getAttribute('data-lightbox-src') || mainImg.getAttribute('src'),
      mainImg.getAttribute('alt')
    );

    container
      .querySelectorAll('[class*="__thumb"]:not([class*="__thumb-"])')
      .forEach(function (thumb) {
        var img = thumb.querySelector('img');
        addSlide(getThumbLargeSrc(img), img ? img.getAttribute('alt') : '');
      });

    return slides;
  }

  function findSlideIndex(slides, src) {
    if (!src || !slides.length) return 0;
    var index = slides.findIndex(function (slide) {
      return slide.src === src;
    });
    return index >= 0 ? index : 0;
  }

  function syncGalleryToSlide(container, mainImg, slide) {
    if (!slide || !mainImg) return;

    mainImg.setAttribute('src', slide.src);
    mainImg.setAttribute('data-lightbox-src', slide.src);
    if (slide.alt) mainImg.setAttribute('alt', slide.alt);

    var thumbs = container.querySelectorAll('[class*="__thumb"]:not([class*="__thumb-"])');
    var matched = false;

    thumbs.forEach(function (thumb) {
      var thumbSrc = getThumbLargeSrc(thumb.querySelector('img'));
      var isMatch = thumbSrc === slide.src;
      thumb.classList.toggle('is-active', isMatch);
      if (isMatch) matched = true;
    });

    if (!matched) {
      thumbs.forEach(function (thumb) {
        thumb.classList.remove('is-active');
      });
    }
  }

  function updateNavButtons() {
    if (!lightboxPrev || !lightboxNext || !lightboxCounter) return;
    var hasMany = galleryState && galleryState.slides.length > 1;
    lightboxPrev.hidden = !hasMany;
    lightboxNext.hidden = !hasMany;
    lightboxCounter.hidden = !hasMany;

    if (hasMany) {
      lightboxCounter.textContent =
        (galleryState.index + 1) + ' / ' + galleryState.slides.length;
    }
  }

  function showSlide(index) {
    if (!galleryState || !galleryState.slides.length) return;

    var total = galleryState.slides.length;
    var nextIndex = index;
    if (nextIndex < 0) nextIndex = total - 1;
    if (nextIndex >= total) nextIndex = 0;

    galleryState.index = nextIndex;
    var slide = galleryState.slides[nextIndex];

    lightboxImage.src = slide.src;
    lightboxImage.alt = slide.alt;
    syncGalleryToSlide(galleryState.container, galleryState.mainImg, slide);
    updateNavButtons();
  }

  function ensureLightbox() {
    if (lightbox) return lightbox;

    lightbox = document.createElement('div');
    lightbox.id = LIGHTBOX_ID;
    lightbox.className = 'kit-product-image-lightbox';
    lightbox.setAttribute('role', 'dialog');
    lightbox.setAttribute('aria-modal', 'true');
    lightbox.setAttribute('aria-label', 'Image agrandie');
    lightbox.innerHTML =
      '<div class="kit-product-image-lightbox__overlay" data-kit-lightbox-close></div>' +
      '<div class="kit-product-image-lightbox__content">' +
      '<button type="button" class="kit-product-image-lightbox__nav kit-product-image-lightbox__nav--prev" data-kit-lightbox-prev aria-label="Image précédente">' +
      '<svg viewBox="0 0 24 24" aria-hidden="true"><polyline points="15 18 9 12 15 6"></polyline></svg>' +
      '</button>' +
      '<div class="kit-product-image-lightbox__stage">' +
      '<img src="" alt="" />' +
      '<button type="button" class="kit-product-image-lightbox__close" data-kit-lightbox-close aria-label="Fermer">' +
      '<svg viewBox="0 0 24 24" aria-hidden="true"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>' +
      '</button>' +
      '<span class="kit-product-image-lightbox__counter" aria-live="polite"></span>' +
      '</div>' +
      '<button type="button" class="kit-product-image-lightbox__nav kit-product-image-lightbox__nav--next" data-kit-lightbox-next aria-label="Image suivante">' +
      '<svg viewBox="0 0 24 24" aria-hidden="true"><polyline points="9 18 15 12 9 6"></polyline></svg>' +
      '</button>' +
      '</div>';

    document.body.appendChild(lightbox);
    lightboxImage = lightbox.querySelector('.kit-product-image-lightbox__stage img');
    lightboxPrev = lightbox.querySelector('[data-kit-lightbox-prev]');
    lightboxNext = lightbox.querySelector('[data-kit-lightbox-next]');
    lightboxCounter = lightbox.querySelector('.kit-product-image-lightbox__counter');

    lightbox.addEventListener('click', function (event) {
      if (event.target.closest('[data-kit-lightbox-close]')) {
        closeLightbox();
        return;
      }
      if (event.target.closest('[data-kit-lightbox-prev]')) {
        event.stopPropagation();
        showSlide(galleryState ? galleryState.index - 1 : 0);
        return;
      }
      if (event.target.closest('[data-kit-lightbox-next]')) {
        event.stopPropagation();
        showSlide(galleryState ? galleryState.index + 1 : 0);
      }
    });

    document.addEventListener('keydown', function (event) {
      if (!lightbox || !lightbox.classList.contains('is-active')) return;

      if (event.key === 'Escape') {
        closeLightbox();
        return;
      }
      if (event.key === 'ArrowLeft') {
        event.preventDefault();
        showSlide(galleryState ? galleryState.index - 1 : 0);
        return;
      }
      if (event.key === 'ArrowRight') {
        event.preventDefault();
        showSlide(galleryState ? galleryState.index + 1 : 0);
      }
    });

    return lightbox;
  }

  function openLightbox(container, mainImg, startSrc, startAlt) {
    if (!startSrc) return;
    ensureLightbox();

    var slides = collectGallerySlides(container, mainImg);
    if (!slides.length) {
      slides = [{ src: startSrc, alt: startAlt || '' }];
    }

    galleryState = {
      container: container,
      mainImg: mainImg,
      slides: slides,
      index: findSlideIndex(slides, startSrc),
    };

    var slide = slides[galleryState.index] || slides[0];
    lightboxImage.src = slide.src;
    lightboxImage.alt = slide.alt || startAlt || '';
    lightbox.classList.add('is-active');
    document.body.classList.add('kit-product-lightbox-open');
    updateNavButtons();
  }

  function closeLightbox() {
    if (!lightbox) return;
    lightbox.classList.remove('is-active');
    document.body.classList.remove('kit-product-lightbox-open');
    lightboxImage.removeAttribute('src');
    galleryState = null;
  }

  function initGallery(container) {
    if (container.getAttribute('data-kit-lightbox-ready') === 'true') return;
    container.setAttribute('data-kit-lightbox-ready', 'true');

    var mainImageWrapper = container.querySelector('[class*="__main-image"]');
    var mainImg = mainImageWrapper ? mainImageWrapper.querySelector('img') : null;
    if (!mainImageWrapper || !mainImg) return;

    rememberInitialSrc(mainImg);
    mainImageWrapper.classList.add('kit-product-lightbox-trigger');

    mainImageWrapper.setAttribute('role', 'button');
    mainImageWrapper.setAttribute('tabindex', '0');
    mainImageWrapper.setAttribute('aria-label', 'Agrandir l\'image');

    function openMainLightbox() {
      var src = getLightboxSrc(container, mainImg);
      openLightbox(container, mainImg, src, mainImg.getAttribute('alt') || '');
    }

    mainImageWrapper.addEventListener('click', openMainLightbox);
    mainImageWrapper.addEventListener('keydown', function (event) {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        openMainLightbox();
      }
    });

    container.addEventListener('click', function (event) {
      var thumb = getThumbItem(event.target);
      if (!thumb) return;
      var largeSrc = getThumbLargeSrc(thumb.querySelector('img'));
      if (largeSrc) {
        mainImg.setAttribute('data-lightbox-src', largeSrc);
      }
    });
  }

  function init() {
    document.querySelectorAll('.page-template__layout').forEach(function (container) {
      if (container.querySelector('[class*="__main-image"]')) {
        initGallery(container);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var container = event.target.querySelector('.page-template__layout');
    if (container && container.querySelector('[class*="__main-image"]')) {
      initGallery(container);
    }
  });
})();
